/// <reference path="typings/jquery.d.ts" />
/// <reference path="typings/quarkplayer.d.ts" />
///<reference path="commons/xhr.ts" />
///<reference path="commons/loadJS.ts" />
///<reference path="commons/cookie.ts" />
///<reference path="plugins/tiak/plugin.ts" />
var playersObject = /** @class */ (function () {
    function playersObject() {
        this.mediaRequestUrl = "/action/media/";
        this.geoBlockingUrl = "https://geoloc.hurriyet.com.tr/api/country";
        this.playerInstances = {};
        this.playlistVideos = [];
        this.pageLifecycleBound = false;
        this.createMedyanetPageSkin();
        this.bindPlayerLifecycleEvents();
        this.videoAreaElement = document.getElementById("video-element");
        var lightboxElement = document.getElementById("lightbox-video");
        var lightboxHide = Cookie.getCookie("lightbox");
        var _this = this;
        if (lightboxElement !== null && lightboxHide === false && window.outerWidth >= 768) {
            _this.addQuarkPlayer();
            _this.elementOptions = {
                id: lightboxElement.dataset.id,
                showAds: (lightboxElement.dataset.ads === "true"),
                autoPlay: (lightboxElement.dataset.autoplay === "true"),
                viewability: (lightboxElement.dataset.viewability === "true"),
                live: (lightboxElement.dataset.live === "true"),
                techOrder: lightboxElement.dataset.live === "true" ? ['flash', 'html5'] : ['html5', 'flash'],
                adType: lightboxElement.dataset.adType,
                elementId: 'lightbox-player-container',
                originalName: lightboxElement.dataset.originalName,
                pqType: lightboxElement.dataset.pqType,
            };
            _this.createMediaServiceQuery(_this.elementOptions);
        }
        if (this.videoAreaElement !== null) {
            /*            document.addEventListener('adservice-prebid-vasturl-prepared', (e: CustomEvent) => {
                            _this.adservicePrebidData = e.detail;
                        });*/
            this.checkGeoBlocking(function () {
                _this.addQuarkPlayer();
                _this.elementOptions = {
                    id: this.videoAreaElement.dataset.id,
                    showAds: (this.videoAreaElement.dataset.ads === "true"),
                    autoPlay: (this.videoAreaElement.dataset.autoplay === "true"),
                    embed: (this.videoAreaElement.dataset.embed !== undefined && (this.videoAreaElement.dataset.embed === "true" || this.videoAreaElement.dataset.embed === "True")),
                    embedUrl: location.protocol + '//' + location.host + '/embed' + this.videoAreaElement.dataset.url,
                    url: location.protocol + '//' + location.host + this.videoAreaElement.dataset.url,
                    slugurl: this.videoAreaElement.dataset.slugurl,
                    contentId: this.videoAreaElement.dataset.id,
                    tag: this.videoAreaElement.dataset.tag != null && this.videoAreaElement.dataset.tag.length > 0 ? this.videoAreaElement.dataset.tag : '',
                    maincat: this.videoAreaElement.dataset.maincat,
                    category: this.videoAreaElement.dataset.category,
                    playtype: this.videoAreaElement.dataset.playtype,
                    pubname: this.videoAreaElement.dataset.pubname,
                    isSpotVideo: "false",
                    viewability: (this.videoAreaElement.dataset.viewability === "true"),
                    live: (this.videoAreaElement.dataset.live === "true"),
                    techOrder: this.videoAreaElement.dataset.live === "true" ? ['flash', 'html5'] : ['html5', 'flash'],
                    adType: this.videoAreaElement.dataset.adType,
                    elementId: 'player-container',
                    logobrand: (this.videoAreaElement.dataset.logoBrand === "true"),
                    vendor: "TV2",
                    originalName: this.videoAreaElement.dataset.originalName,
                    pqType: this.videoAreaElement.dataset.pqType,
                    publishedDate: this.videoAreaElement.dataset.publishedDate,
                    broadcastScheduleTime: this.videoAreaElement.dataset.broadcastScheduleTime || ""
                };
                _this.createMediaServiceQuery(_this.elementOptions);
            }.bind(this));
        }
        this.playlistContainer = document.querySelector('.playlist-container');
        if (this.playlistContainer !== null) {
            this.createPlaylist(this.playlistContainer);
        }
    }
    playersObject.prototype.getQuarkPlayerVersion = function () {
        return document.body.dataset["playerVersion"];
    };
    playersObject.prototype.addQuarkPlayer = function () {
        var quarkPlayerVersion = this.getQuarkPlayerVersion();
        console.log("window.hasAdBlock", window.hasAdBlock);
        if (window.hasAdBlock) {
            document.querySelector('.player-warning.hidden').style.display = 'block';
        }
        else {
            var loadJS = new LoadJS();
            loadJS.loadSync('//imasdk.googleapis.com/js/sdkloader/ima3.js?v=1');
            loadJS.loadSync('https://player.tv2.com.tr/q/s/player/html5/' + quarkPlayerVersion + '/assets/js/docs.min.js');
        }
    };
    playersObject.prototype.createMedyanetPageSkin = function () {
        window.Medyanet_Pageskin = function (pageskin) {
            var pageskinHtml = '<a href="' + pageskin.ClickUrl + '" target="_blank" class="hidden-md-down">' +
                '<img src="' + pageskin.CreativeSource + '">' +
                '</a>' +
                '<a href="' + pageskin.ClickUrl + '" target="_blank" class="hidden-lg-up">' +
                '<img src="' + pageskin.CreativeSourceMobile + '">' +
                '</a>' +
                '<img src="' + pageskin.ImpresssionUrl + '" style="position: absolute; width: 1px; height: 1px;">';
            if (pageskin.ImpresssionTrackingUrl) {
                pageskinHtml += '<img src="' + pageskin.ImpresssionTrackingUrl + '" style="position: absolute; width: 1px; height: 1px;">';
            }
            document.querySelector('.page-skin').innerHTML = pageskinHtml;
        };
    };
    playersObject.prototype.createMediaServiceQuery = function (options) {
        options.id = options.id.replace('/', '');
        var _this = this;
        var xhr = new Xhr();
        var requestUrl = this.mediaRequestUrl + options.id;
        xhr.getJSON(requestUrl, function (data) {
            if (data.Status === 'Success') {
                if (typeof data && data.Media && data.Media.Image !== 'undefined') {
                    options.poster = data.Media.Image + '.jpg';
                }
                else {
                    options.poster = '';
                }
                if (data.Media.Link.ServiceUrl) {
                    options.source = {
                        src: data.Media.Link.ServiceUrl + '/' + data.Media.Link.SecurePath,
                        type: 'application/x-mpegURL'
                    };
                }
                else {
                    options.source = {
                        src: (data.Media.Link.SecurePath.indexOf('http') > -1 ? '' : 'https://tv2.duhnet.tv') + (data.Media.Link.SecurePath.indexOf('/') === 0 || data.Media.Link.SecurePath.indexOf('http') > -1 ? data.Media.Link.SecurePath : '/' + data.Media.Link.SecurePath),
                        type: data.Media.Link.SecurePath.indexOf('.mp4') > -1 ? 'video/mp4' : 'application/x-mpegURL'
                    };
                }
                var url = new URL(options.source.src);
                var maxMin = 'min=0&max=2500';
                if ((window.innerWidth < 768)) {
                    maxMin = 'min=0&max=1250';
                }
                var live = options.live === "true" ? '&live=true' : '';
                var app = '&app=com.tv2';
                // query string de bişeyler varsa
                if (url.search.indexOf('?') > -1) {
                    maxMin = "&" + maxMin;
                }
                else {
                    maxMin = "?" + maxMin;
                }
                options.source.src = options.source.src + maxMin + live + app;
                options.UserName = data.User.Name;
                options.SessionId = data.User.SessionId;
                var initQuarkPlayer = function () {
                    if (typeof QuarkPlayer !== 'undefined') {
                        if (typeof googlefc !== 'undefined' && window.location.host.indexOf("local") === -1) {
                            googlefc.callbackQueue.push({
                                'CONSENT_DATA_READY': function () { return _this.createQuarkInstance(options); }
                            });
                        }
                        else {
                            _this.createQuarkInstance(options);
                        }
                    }
                };
                setTimeout(initQuarkPlayer, 500);
            }
            else {
            }
        }, function (status) {
            //alert('Birşeyler ters gitti');
        });
    };
    playersObject.prototype.createQuarkInstance = function (elementOptions) {
        if (this.playerInstances[elementOptions.id]) {
            this.disposePlayerInstance(elementOptions.id);
        }
        this.clearPlayerContainer(elementOptions.elementId);
        var embedAdType = "embed";
        if (document.referrer.indexOf('hurriyet.com') > -1 || document.referrer.indexOf('milliyet.com') > -1 ||
            document.referrer.indexOf('posta.com') > -1 || document.referrer.indexOf('fanatik.com') > -1 ||
            document.referrer.indexOf('fanatik.com') > -1 || document.referrer.indexOf('dreamtv.com') > -1 ||
            document.referrer.indexOf('dreamturk.com') > -1 || document.referrer.indexOf('cnnturk.com') > -1 ||
            document.referrer.indexOf('radyod.com') > -1 || document.referrer.indexOf('kanald.com') > -1 ||
            document.referrer.indexOf('vatan.com') > -1 || document.referrer.indexOf('netd.com') > -1 || document.referrer.indexOf('tv2') > -1) {
            embedAdType = "DEmbed";
        }
        console.log('ELEMENT OPTIONS', elementOptions);
        var cookies = Cookie.getCookie("M_BK");
        var options = {
            id: elementOptions.elementId,
            materialId: elementOptions.id,
            broadcastScheduleTime: elementOptions.broadcastScheduleTime || "",
            debug: false,
            techOrder: ['html5'],
            autoPlay: elementOptions.autoPlay,
            viewability: elementOptions.viewability,
            showAds: elementOptions.showAds,
            embedUrl: location.protocol + '//' + location.host + '/embed' + elementOptions.url,
            url: location.protocol + '//' + location.host + elementOptions.url,
            slugurl: elementOptions.slugurl,
            embed: elementOptions.embed,
            contentId: elementOptions.id,
            category: elementOptions.category,
            tag: elementOptions.tag,
            pubname: elementOptions.pubname,
            maincat: elementOptions.maincat,
            playtype: elementOptions.playtype,
            isSpotVideo: elementOptions.isSpotVideo,
            showNotification: false,
            showBandwidthSelector: true,
            customMenu: true,
            live: elementOptions.live,
            originalName: elementOptions.originalName,
            pqType: elementOptions.pqType,
            publishedDate: elementOptions.publishedDate,
            poster: elementOptions.poster,
            sources: [elementOptions.source],
            subTitles: null,
            playsinline: true,
            // Birden çok targetı bir arada kullanabilmek için VMAP kullanılmalıdır. VMAP açıklamasına dökümandan ulaşılabilir
            adTagUrl: 'https://www.tv2.com.tr/action/vmap?id=' + elementOptions.id + (elementOptions.adType ? '&adType=' + elementOptions.adType : '') + '&embedAdType=' + embedAdType + "&plcmt=1",
            plugins: [playerEvent, AdsManagerPlugin, BdmpPlugin, tiakPlugin],
            stats: {
                gemius: {
                    identifier: "dw.q8cb623JEXnnyE2dkL6PeHUvu8Ucmwu8LvtsUIzD.47"
                },
                comscore: {
                    c1: "1",
                    c2: "9053247",
                    c3: "TV2"
                }
            },
            ima: {
                adWillAutoPlay: elementOptions.autoPlay
            },
            hlsCustomBandwithSelector: function () {
                this.on('loadedmetadata', function () {
                    var player = this;
                    var levels = [{
                            speed: 9999,
                            text: 'Otomatik',
                            index: -1
                        }];
                    var levelTextMap = {
                        500: '360p',
                        1000: '480p',
                        1500: '720p'
                    };
                    // 1080p mobilde görünmeyecek
                    if (!(window.innerWidth < 768)) {
                        levelTextMap[2500] = '1080p';
                    }
                    this.hlsjs.levels.forEach(function (level, index) {
                        level.url.forEach(function (url) {
                            var matched = url.match(/\/\d+\//);
                            if (matched) {
                                var speed = parseInt(matched[0].replace(/\//g, ''));
                                if (typeof levelTextMap[speed] !== 'undefined') {
                                    levels.push({
                                        speed: speed,
                                        text: levelTextMap[speed],
                                        index: index
                                    });
                                }
                            }
                        });
                    });
                    levels.sort(function (a, b) { return b.speed - a.speed; });
                    if (levels.length) {
                        // set best quality to current level
                        player.hlsjs.currentLevel = levels[0].index;
                        var $container = document.createElement('div');
                        $container.setAttribute('id', 'bandwidth-selector');
                        $container.setAttribute('class', 'vjs-settings-button vjs-menu-button vjs-menu-button-popup vjs-control vjs-icon-cog');
                        var $menu = document.createElement('div');
                        $menu.setAttribute('class', 'vjs-menu');
                        $container.appendChild($menu);
                        var $content_1 = document.createElement('ul');
                        $content_1.setAttribute('class', 'vjs-menu-content');
                        $menu.appendChild($content_1);
                        levels.forEach(function (level, index) {
                            var $quality = document.createElement('li');
                            $quality.setAttribute('class', 'vjs-menu-item');
                            if (index === 0) {
                                $quality.classList.add('vjs-selected');
                            }
                            $quality.addEventListener('click', function () {
                                var $selected = $content_1.querySelector('.vjs-selected');
                                if ($selected) {
                                    $selected.classList.remove('vjs-selected');
                                }
                                $quality.classList.add('vjs-selected');
                                player.hlsjs.currentLevel = level.index;
                            });
                            $quality.innerText = level.text;
                            $content_1.appendChild($quality);
                        });
                        this.controlBar.el_.insertBefore($container, this.controlBar.fullscreenToggle.el_);
                    }
                });
            }
        };
        if (this.adservicePrebidData && this.adservicePrebidData.vastUrls && this.adservicePrebidData.vastUrls.length > 0 && this.adservicePrebidData.playerId === elementOptions.elementId) {
            var offsets_1 = {
                preroll: 'start',
                midroll: '00:00:15.000',
                postroll: 'end'
            };
            var adTags = this.adservicePrebidData.vastUrls.map(function (vastUrl) {
                return {
                    id: vastUrl.type,
                    type: 'linear',
                    url: vastUrl.vastUrl,
                    offset: offsets_1[vastUrl.type]
                };
            });
            options['adTagUrl'] = null;
            options['adTags'] = adTags;
        }
        var prepareLabel = function (data) {
            var result = '';
            result += 'VEmbedUrl:' + data.embedUrl + '|';
            result += 'VUrl:' + data.url + '|';
            result += 'VSlugTitle:' + data.slugurl + '|';
            result += 'VContentId:' + data.contentId + '|';
            result += 'VMainCat:' + data.maincat + '|';
            result += 'VCat:' + data.category + '|';
            result += 'VTags:' + data.tag + '|';
            result += 'VIsSpotVideo:' + data.isSpotVideo + '|';
            result += 'VPlayType:' + data.playtype + '|';
            result += 'PubName:' + data.pubname;
            return result;
        };
        if (elementOptions.logobrand === true) {
            options["logobrand"] = {
                image: "https://static.tv2.com.tr/assets/img/player_button.png",
                destination: "https://www.tv2.com.tr/"
            };
        }
        var _this = this;
        _this.playerInstances[elementOptions.id] = new QuarkPlayer(options);
        _this.bindUserPlaybackIntent(_this.playerInstances[elementOptions.id]);
        _this.playerInstances[elementOptions.id].player.on('allended', function (e) {
            _this.similarVideosOptions();
        });
        _this.playerInstances[elementOptions.id].player.on('ads-manager-all-ads-completed', function (e) {
            _this.videoEndedPlaylistHandler();
        });
        _this.playerInstances[elementOptions.id].player.on('play', function (e) {
            var _this = this;
            if (!this.analyticsTriggered) {
                _this.analyticsTriggered = true;
                try {
                    ga('send', 'event', 'Videos', 'play', window.location.pathname);
                    if (playerObjects.elementOptions.embed) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'VMS',
                            eventAction: 'Started',
                            eventLabel: prepareLabel(playerObjects.elementOptions)
                        });
                    }
                }
                catch (err) {
                    //console.log('analytics err', err);
                }
            }
        });
        var lightbox = $('#lightbox-video');
        if (lightbox.length != 0) {
            lightbox.on('hidden.bs.modal', function (e) {
                if (_this.playerInstances[elementOptions.id] && _this.playerInstances[elementOptions.id].options.id == "lightbox-player-container") {
                    _this.disposePlayerInstance(elementOptions.id);
                }
            });
        }
    };
    playersObject.prototype.clearPlayerContainer = function (elementId) {
        var playerContainer = document.getElementById(elementId);
        if (!playerContainer) {
            return;
        }
        while (playerContainer.firstChild) {
            playerContainer.removeChild(playerContainer.firstChild);
        }
    };
    playersObject.prototype.bindUserPlaybackIntent = function (playerInstance) {
        if (!playerInstance || !playerInstance.player) {
            return;
        }
        var player = playerInstance.player;
        var userInteractionWindow = 1500;
        var lastUserInteractionAt = 0;
        var hasStarted = false;
        var markUserInteraction = function () {
            lastUserInteractionAt = Date.now();
        };
        var hasRecentUserInteraction = function () {
            return Date.now() - lastUserInteractionAt < userInteractionWindow;
        };
        var getPlayerElement = function () {
            if (typeof player.el === 'function') {
                return player.el();
            }
            if (player.el_) {
                return player.el_;
            }
            if (playerInstance.options && playerInstance.options.id) {
                return document.getElementById(playerInstance.options.id);
            }
            return null;
        };
        var playerElement = getPlayerElement();
        if (playerElement) {
            playerElement.addEventListener('click', markUserInteraction);
            playerElement.addEventListener('touchstart', markUserInteraction);
            playerElement.addEventListener('keydown', markUserInteraction);
        }
        player.on('pause', function () {
            if (playerInstance.tv2InternalPause) {
                playerInstance.tv2InternalPause = false;
                return;
            }
            if (hasStarted && hasRecentUserInteraction()) {
                playerInstance.tv2UserPaused = true;
            }
        });
        player.on('play', function () {
            if (playerInstance.tv2UserPaused) {
                if (hasRecentUserInteraction()) {
                    playerInstance.tv2UserPaused = false;
                    hasStarted = true;
                    return;
                }
                playerInstance.tv2InternalPause = true;
                setTimeout(function () {
                    try {
                        if (typeof player.pause === 'function') {
                            player.pause();
                        }
                    }
                    catch (err) {
                    }
                }, 0);
                return;
            }
            hasStarted = true;
        });
        player.on('dispose', function () {
            if (playerElement) {
                playerElement.removeEventListener('click', markUserInteraction);
                playerElement.removeEventListener('touchstart', markUserInteraction);
                playerElement.removeEventListener('keydown', markUserInteraction);
            }
        });
    };
    playersObject.prototype.bindPlayerLifecycleEvents = function () {
        if (this.pageLifecycleBound) {
            return;
        }
        var _this = this;
        this.pageLifecycleBound = true;
        window.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                _this.pauseAllPlayers();
            }
        });
        window.addEventListener('pagehide', function () {
            _this.disposeAllPlayers();
        });
        window.addEventListener('beforeunload', function () {
            _this.disposeAllPlayers();
        });
        window.addEventListener('tv2_unload', function () {
            _this.disposeAllPlayers();
        });
    };
    playersObject.prototype.pauseAllPlayers = function () {
        for (var playerId in this.playerInstances) {
            if (this.playerInstances.hasOwnProperty(playerId)) {
                this.pausePlayerInstance(this.playerInstances[playerId]);
            }
        }
    };
    playersObject.prototype.disposeAllPlayers = function () {
        var _this = this;
        var playerIds = [];
        for (var playerId in this.playerInstances) {
            if (this.playerInstances.hasOwnProperty(playerId)) {
                playerIds.push(playerId);
            }
        }
        playerIds.forEach(function (playerId) {
            _this.disposePlayerInstance(playerId);
        });
    };
    playersObject.prototype.pausePlayerInstance = function (playerInstance) {
        if (!playerInstance) {
            return;
        }
        try {
            if (playerInstance.player && typeof playerInstance.player.pause === 'function') {
                playerInstance.tv2InternalPause = true;
                playerInstance.player.pause();
            }
        }
        catch (err) {
        }
        try {
            if (playerInstance.player && playerInstance.player.ima && typeof playerInstance.player.ima.getAdsManager === 'function') {
                var adsManager = playerInstance.player.ima.getAdsManager();
                if (adsManager && typeof adsManager.pause === 'function') {
                    adsManager.pause();
                }
                if (adsManager && typeof adsManager.setVolume === 'function') {
                    adsManager.setVolume(0);
                }
            }
        }
        catch (err) {
        }
    };
    playersObject.prototype.disposePlayerInstance = function (playerId) {
        var playerInstance = this.playerInstances[playerId];
        if (!playerInstance) {
            return;
        }
        this.pausePlayerInstance(playerInstance);
        try {
            if (typeof playerInstance.dispose === 'function') {
                playerInstance.dispose();
            }
            else if (playerInstance.player && typeof playerInstance.player.dispose === 'function') {
                playerInstance.player.dispose();
            }
        }
        catch (err) {
        }
        delete this.playerInstances[playerId];
    };
    playersObject.prototype.similarVideosOptions = function () {
        var _this = this;
        var similarVideosWrapper = $('#similar-videos-wrapper');
        if (similarVideosWrapper.length) {
            var upNextElement_1 = $('#similar-videos-wrapper .up-next');
            similarVideosWrapper.removeClass('hidden-xs-up');
            var seconds_1 = 8;
            var count = $('#similar-videos-wrapper .similar-videos a').length;
            var item = $('#similar-videos-wrapper .similar-videos a').eq(0);
            if (item && item.attr('href') !== undefined) {
                upNextElement_1.find('h2').html(item.attr('title'));
                upNextElement_1.find('img').attr('src', item.data('image'));
                _this.similarInterval = setInterval(function () {
                    seconds_1--;
                    if (seconds_1 < 0) {
                        clearInterval(_this.similarInterval);
                        var nextLink = $('.up-next-loader').attr('href');
                        window.location.href = nextLink;
                    }
                }, 1000);
            }
            document.getElementById("cancel-upnext").addEventListener("click", function () {
                clearInterval(_this.similarInterval);
                upNextElement_1.addClass('hidden-xs-up');
            });
        }
    };
    playersObject.prototype.checkGeoBlocking = function (callback) {
        var _this = this;
        _this.isGeoBlockingActive = _this.videoAreaElement.dataset.geoBlocking == 'true';
        _this.geoBlockingCountries = _this.videoAreaElement.dataset.geoBlockingCountries
            ? _this.videoAreaElement.dataset.geoBlockingCountries.split(',').filter(function (i) { return i; })
            : false;
        if (_this.isGeoBlockingActive && _this.geoBlockingCountries) {
            $.ajax({
                type: "GET",
                url: _this.geoBlockingUrl,
                success: function (data, textStatus, jqXHR) {
                    if (data
                        && data.hasOwnProperty('CountryCode')
                        && _this.geoBlockingCountries.includes(data.CountryCode)) {
                        _this.videoAreaElement.classList.add("geo-blocking");
                    }
                    else {
                        callback();
                    }
                },
                error: function () {
                    callback();
                }
            });
        }
        else {
            callback();
        }
    };
    playersObject.prototype.createPlaylist = function ($container) {
        var _this = this;
        $container.querySelectorAll('a[data-id]').forEach(function (element) {
            // sonraki videoya geçmede kullanmak için saklıyoruz
            _this.playlistVideos.push(element.getAttribute('data-id'));
            element.addEventListener('click', function (event) {
                event.preventDefault();
                var activeId = _this.elementOptions.id;
                var nextId = element.getAttribute('data-id');
                var metaData = {
                    title: element.getAttribute('data-title'),
                    description: element.getAttribute('data-description'),
                    backgroundImage: element.getAttribute('data-background')
                };
                console.log('playlistItem', activeId);
                _this._playlistNextVideo(activeId, nextId, metaData);
            });
        });
    };
    playersObject.prototype.videoEndedPlaylistHandler = function () {
        var playlistContainer = this.playlistContainer;
        if (!playlistContainer) {
            return false;
        }
        if (!this.playlistVideos.length) {
            return false;
        }
        var activePlayerIndex = this.playlistVideos.indexOf(this.elementOptions.id);
        if (activePlayerIndex < 0) {
            activePlayerIndex = 0;
        }
        var nextIndex = activePlayerIndex + 1;
        if (nextIndex !== this.playlistVideos.length) {
            var activeId = this.elementOptions.id;
            var nextId = this.playlistVideos[nextIndex];
            var element = playlistContainer.querySelector('a[data-id="' + nextId + '"]');
            var metaData = {
                title: element.getAttribute('data-title'),
                description: element.getAttribute('data-description'),
                backgroundImage: element.getAttribute('data-background')
            };
            this._playlistNextVideo(activeId, nextId, metaData);
        }
    };
    playersObject.prototype._playlistNextVideo = function (activeId, nextId, metaData) {
        this.disposePlayerInstance(activeId);
        // tıklanan playerı oynat
        this.elementOptions.id = nextId;
        this.createMediaServiceQuery(this.elementOptions);
        // playerın altındaki title, description vs güncelle
        var player = this.playlistContainer.querySelector('.player');
        player.querySelector('#video-element').setAttribute('data-id', nextId);
        player.querySelector('.desc-title').innerText = metaData.title;
        player.querySelector('.desc-info .nano-content').innerText = metaData.description;
        var shareInput = this.playlistContainer.querySelector('#input-iframe-code');
        var playlistSection = document.querySelector('.section-video-playlist-detail');
        var blurredBg = playlistSection.querySelector('.blurred-bg');
        if (playlistSection !== null) {
            playlistSection.setAttribute('data-share-image', metaData.backgroundImage);
        }
        if (blurredBg !== null) {
            blurredBg.style.backgroundImage = "url(" + metaData.backgroundImage + ")";
        }
        if (shareInput !== null) {
            shareInput
                .setAttribute('value', "<iframe src=\"https://tv2.com.tr/embed/" + nextId + "\" width=560 height=315 frameborder=0 allowfullscreen></iframe>");
        }
    };
    return playersObject;
}());
function AdsManagerPlugin() {
    var player = this;
    var adsManager = null;
    var nonLinearFinishTimeout = null;
    var ADS_STATE = {
        IS_ADS_PLAYING: false,
        IS_ADS_INITIALIZED: false,
    };
    var finishAds = function () {
        ADS_STATE.IS_ADS_PLAYING = false;
        player.trigger("ads-manager-ads-finished");
    };
    var syncAdsVolume = function () {
        if (!adsManager || typeof adsManager.setVolume !== 'function') {
            return;
        }
        try {
            var isMuted = typeof player.muted === 'function' ? player.muted() : false;
            var volume = typeof player.volume === 'function' ? player.volume() : 1;
            adsManager.setVolume(isMuted ? 0 : volume);
        }
        catch (err) {
        }
    };
    var pauseAds = function () {
        if (!adsManager) {
            return;
        }
        syncAdsVolume();
        try {
            if (typeof adsManager.pause === 'function') {
                adsManager.pause();
            }
        }
        catch (err) {
        }
    };
    var resumeAds = function () {
        if (!adsManager || !ADS_STATE.IS_ADS_PLAYING) {
            return;
        }
        syncAdsVolume();
        try {
            if (typeof adsManager.resume === 'function') {
                adsManager.resume();
            }
        }
        catch (err) {
        }
    };
    var stopAds = function () {
        if (nonLinearFinishTimeout) {
            clearTimeout(nonLinearFinishTimeout);
            nonLinearFinishTimeout = null;
        }
        if (adsManager) {
            try {
                if (typeof adsManager.pause === 'function') {
                    adsManager.pause();
                }
            }
            catch (err) {
            }
            try {
                if (typeof adsManager.destroy === 'function') {
                    adsManager.destroy();
                }
            }
            catch (err) {
            }
        }
        ADS_STATE.IS_ADS_PLAYING = false;
    };
    var onPageHidden = function () {
        pauseAds();
    };
    var onPageLeave = function () {
        stopAds();
    };
    var onVisibilityChange = function () {
        if (document.hidden) {
            pauseAds();
        }
    };
    window.addEventListener('pagehide', onPageLeave);
    window.addEventListener('beforeunload', onPageLeave);
    window.addEventListener('tv2_unload', onPageLeave);
    window.addEventListener('blur', onPageHidden);
    document.addEventListener('visibilitychange', onVisibilityChange);
    this.on("adsready", function () {
        ADS_STATE.IS_ADS_INITIALIZED = true;
        adsManager = this.ima.getAdsManager();
        syncAdsVolume();
        var addAdListener = function (type, callback) {
            if (type) {
                adsManager.addEventListener(type, callback);
            }
        };
        addAdListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function () {
            ADS_STATE.IS_ADS_PLAYING = true;
            syncAdsVolume();
            player.trigger("ads-manager-ads-started", true);
        });
        addAdListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, finishAds);
        addAdListener(google.ima.AdEvent.Type.USER_CLOSE, finishAds);
        addAdListener(google.ima.AdEvent.Type.COMPLETE, finishAds);
        addAdListener(google.ima.AdEvent.Type.SKIPPED, finishAds);
        addAdListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, finishAds);
        addAdListener(google.ima.AdEvent.Type.STARTED, function (event) {
            var ad = event.getAd();
            if (!ad.isLinear()) {
                ADS_STATE.IS_ADS_PLAYING = true;
                syncAdsVolume();
                player.trigger("ads-manager-ads-started", false);
                var minSuggestedDuration = ad.getMinSuggestedDuration();
                if (minSuggestedDuration > 0) {
                    nonLinearFinishTimeout = setTimeout(function () {
                        ADS_STATE.IS_ADS_PLAYING = false;
                        player.trigger("ads-manager-ads-finished");
                        nonLinearFinishTimeout = null;
                    }, minSuggestedDuration * 1000);
                }
            }
        });
    });
    this.on("pause", function () {
        pauseAds();
    });
    this.on("play", function () {
        resumeAds();
    });
    this.on("volumechange", function () {
        syncAdsVolume();
    });
    this.one("ended", function () {
        if (!ADS_STATE.IS_ADS_INITIALIZED) {
            player.trigger("ads-manager-all-ads-completed");
        }
        else {
            var timeoutCount_1 = 0;
            var timeoutMax_1 = 10;
            var timeoutInterval_1 = setInterval(function () {
                timeoutCount_1++;
                if (timeoutCount_1 >= timeoutMax_1) {
                    clearInterval(timeoutInterval_1);
                    player.trigger("ads-manager-all-ads-completed");
                }
                if (ADS_STATE.IS_ADS_PLAYING) {
                    clearInterval(timeoutInterval_1);
                    var finishedCount_1 = 0;
                    var finishedMax_1 = 300;
                    var finishedInterval_1 = setInterval(function () {
                        finishedCount_1++;
                        if (finishedCount_1 >= finishedMax_1) {
                            clearInterval(finishedInterval_1);
                            player.trigger("ads-manager-all-ads-completed");
                        }
                        if (!ADS_STATE.IS_ADS_PLAYING) {
                            clearInterval(finishedInterval_1);
                            player.trigger("ads-manager-all-ads-completed");
                        }
                    }, 200);
                }
            }, 300);
        }
    });
    this.on("dispose", function () {
        stopAds();
        window.removeEventListener('pagehide', onPageLeave);
        window.removeEventListener('beforeunload', onPageLeave);
        window.removeEventListener('tv2_unload', onPageLeave);
        window.removeEventListener('blur', onPageHidden);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        this.off("ads-manager-all-ads-completed");
        this.off("ads-manager-ads-started");
        this.off("ads-manager-ads-finished");
    });
}
function playerEvent(options) {
    var player = this;
    this.subscribe = function (event, callback) {
        if (event && callback) {
            player.on(event, callback);
        }
    };
}
function BdmpPlugin(options) {
    var _player = this;
    var _options = options;
    var playTimeInterval = null;
    // Video meta data yüklendiğinde
    // model oluşturacak data elde edebiliyoruz.
    this.on("loadedmetadata", function () {
        if (!_options.publishedDate) {
            return;
        }
        // Video oynatılırken arka planda periyodik bir işlem tutulur.
        _player.on('playing', function () {
            if (!playTimeInterval) {
                playTimeInterval = setInterval(function () {
                    _player.currentTime();
                }, 10 * 1000);
            }
        });
        // Video durduğunda aralıklı işleme son verilir.
        _player.on('pause', function () {
            if (playTimeInterval) {
                clearInterval(playTimeInterval);
                playTimeInterval = null;
            }
        });
    });
}
var playerObjects = new playersObject();
//# sourceMappingURL=players.js.map
